import {useTheme} from '@mui/material';
import {ProvidersDentalGuide} from 'domain/usecases';
import React, {useState} from 'react';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {getAddressforMaps} from 'presentation/utils';

export function useOdontoGuideCard(provider: ProvidersDentalGuide) {
	const theme = useTheme();

	const address = getAddressforMaps({
		address: provider.logradouro,
		complement: provider.complemento,
		district: provider.bairro,
		city: provider.cidade,
		state: provider.uf,
		zipCode: provider.cep,
		number: provider.numero,
	});

	const phoneNumbers = provider?.contatos || [];

	const [openDetails, setOpenDetails] = useState(false);
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [showEmptyPhoneSnackbar, setShowEmptyPhoneSnackbar] = useState(false);
	const [selectedProviderState, setSelectedProviderState] = useState<ProvidersDentalGuide>();

	const {isMobile} = useMediaQueries();

	const phoneNumbersLength = phoneNumbers.length;
	const isPhoneNumberEmpty = phoneNumbersLength === 0;
	const hasMoreThanOnePhoneNumber = phoneNumbersLength > 1;
	const shouldCallDirectlyToOnlyPhone = phoneNumbersLength === 1 && isMobile;
	const shouldOpenPhoneDrawer = hasMoreThanOnePhoneNumber && isMobile;
	const isPhoneNumberMenuOpen = Boolean(anchorEl);
	const showPhonesDrawer = isMobile && hasMoreThanOnePhoneNumber;
	const hasPhoneNumbers = phoneNumbers?.length > 0;

	const handleOpenDetails = () => {
		setSelectedProviderState(provider);
		setOpenDetails(true);
	};

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isPhoneNumberEmpty) {
			setShowEmptyPhoneSnackbar(true);
			return;
		}

		if (shouldCallDirectlyToOnlyPhone) {
			window.location.href = `tel:${phoneNumbers[0]}`;
			return;
		}

		if (shouldOpenPhoneDrawer) {
			setOpenPhoneDrawerState(true);
			return;
		}

		setAnchorEl(event.currentTarget);
	};

	const shouldShowQualifications = provider?.qualificacoes?.length > 0;

	return {
		shouldShowQualifications,
		address,
		phoneNumbers,
		isPhoneNumberMenuOpen,
		showPhonesDrawer,
		hasPhoneNumbers,
		handleOpenDetails,
		handleOpenPhoneMenu,
		openDetails,
		setOpenDetails,
		openPhoneDrawerState,
		setOpenPhoneDrawerState,
		anchorEl,
		setAnchorEl,
		showEmptyPhoneSnackbar,
		setShowEmptyPhoneSnackbar,
		selectedProviderState,
		theme,
	};
}
